import {
  EventNotificationErrorTypeId,
  EventNotificationFilterByTerm,
  EventNotificationSortByTerm,
  EventNotificationStatus,
  EventNotificationTypeId,
  FilterOperator,
} from '@bechtel/types';
import { t } from '@lingui/macro';
import moment from 'moment';

export const enum Error {
  'ALL' = 'ALL',
}

export type EventErrorTypes = Error | EventNotificationErrorTypeId;

export const enum Status {
  'ALL' = 'ALL',
}

export type EventStatusTypes = Status | EventNotificationStatus;

export const enum Schedule {
  '8PM' = '8PM',
  '12AM' = '12AM',
  '6AM' = '6AM',
  'NOW' = 'NOW',
}

export const errorList = [
  { id: Error.ALL, value: Error.ALL, label: t`All` },
  {
    id: EventNotificationErrorTypeId.TRANSIENT,
    value: EventNotificationErrorTypeId.TRANSIENT,
    label: t`Transient`,
  },
  {
    id: EventNotificationErrorTypeId.NONTRANSIENT,
    value: EventNotificationErrorTypeId.NONTRANSIENT,
    label: t`Non Transient`,
  },
];

export const notificationTypes = [
  {
    id: EventNotificationTypeId.ALL,
    value: EventNotificationTypeId.ALL,
    label: t`All`,
  },
  { id: EventNotificationTypeId.INBOUND, value: EventNotificationTypeId.INBOUND, label: t`Inbound` },
  {
    id: EventNotificationTypeId.OUTBOUND,
    value: EventNotificationTypeId.OUTBOUND,
    label: t`Outbound`,
  },
];

export const statusList = [
  { id: EventNotificationStatus.SUCCESS, value: EventNotificationStatus.SUCCESS, label: t`Success` },
  { id: EventNotificationStatus.ERROR, value: EventNotificationStatus.ERROR, label: t`Error` },
  { id: EventNotificationStatus.PUBLISH, value: EventNotificationStatus.PUBLISH, label: t`Publish` },
];

export const scheduleList = [
  { id: Schedule['NOW'], value: Schedule['NOW'], label: t`Now` },
  {
    id: Schedule['8PM'],
    value: Schedule['8PM'],
    label: t`After Shift End (8PM)`,
    datetime: moment().hours(20).startOf('hour').toISOString(),
  },
  {
    id: Schedule['12AM'],
    value: Schedule['12AM'],
    label: t`Midnight (12AM)`,
    datetime: moment().add(1, 'days').hours(0).startOf('hour').toISOString(),
  },
  {
    id: Schedule['6AM'],
    value: Schedule['6AM'],
    label: t`Early Morning (6AM)`,
    datetime: moment().add(1, 'days').hours(6).startOf('hour').toISOString(),
  },
];

export const sortByList = [
  {
    id: EventNotificationSortByTerm['CREATED_AT'],
    value: EventNotificationSortByTerm['CREATED_AT'],
    label: t`Created At`,
  },
  {
    id: EventNotificationSortByTerm['NEXT_SCHEDULE_AT'],
    value: EventNotificationSortByTerm['NEXT_SCHEDULE_AT'],
    label: t`Next Schedule At`,
  },
  {
    id: EventNotificationSortByTerm['ENTITY_TYPE_ID'],
    value: EventNotificationSortByTerm['ENTITY_TYPE_ID'],
    label: t`Entity Type Id`,
  },
  {
    id: EventNotificationSortByTerm['NOTIFICATION_TYPE_ID'],
    value: EventNotificationSortByTerm['NOTIFICATION_TYPE_ID'],
    label: t`Notification Type Id`,
  },
  {
    id: EventNotificationSortByTerm['STATUS'],
    value: EventNotificationSortByTerm['STATUS'],
    label: t`Status`,
  },
  {
    id: EventNotificationSortByTerm['UPDATED_AT'],
    value: EventNotificationSortByTerm['UPDATED_AT'],
    label: t`Updated At`,
  },
  {
    id: EventNotificationSortByTerm['RETRY_COUNT'],
    value: EventNotificationSortByTerm['RETRY_COUNT'],
    label: t`Retry Count`,
  },
];

export const getErrorFilter = (selectedErrorType: EventErrorTypes) => {
  let filter: any;
  switch (selectedErrorType) {
    case EventNotificationErrorTypeId.TRANSIENT:
      filter = {
        operator: FilterOperator.EQUALS,
        term: EventNotificationFilterByTerm.ERROR_TYPE,
        value: EventNotificationErrorTypeId.TRANSIENT,
      };
      break;

    case EventNotificationErrorTypeId.NONTRANSIENT:
      filter = {
        operator: FilterOperator.EQUALS,
        term: EventNotificationFilterByTerm.ERROR_TYPE,
        value: EventNotificationErrorTypeId.NONTRANSIENT,
      };
      break;
    default:
      break;
  }
  return filter;
};

export const getStatusFilter = (selectedStatus: EventStatusTypes[]) => {
  return {
    operator: FilterOperator.IN,
    term: EventNotificationFilterByTerm.STATUS,
    values: selectedStatus,
  };
};
